import { render } from "./App.vue?vue&type=template&id=e2f74ebc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e2f74ebc&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/elearning.liveabc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__